
/**
 * type이 User일 경우, 조회할 사용자의 ID
 */
export type UserIdParam3Parameter = string;
